export enum SalesRoles {
	Default = 0,
	BUYER = 1,
	SELLER = 2,
	BOTH = 3,
}
